import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { SelectPage } from '../';
import { UserMarketing as User, MasterMarketing as Master, TenderMarketing as Tender, SubscriberMarketing as Subscriber } from '@providers/index';

@Component({
  selector: 'page-list-subscribers',
  templateUrl: 'page.html'
})
export class ListTenderSubscribersPage {

  akses:any={};

  user:any={};
  params:any={};
  list:any=[];
  employee = {
    user_id :'',
    name    :''
  };
  tender_id:0;
  subscribe_status:boolean;

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public userApi: User,
    public tenderApi: Tender,
    public subsApi: Subscriber,
    public toastCtrl:ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl : ModalController,
    public navParams: NavParams,
    public alertCtrl: AlertController
    ) {
    this.user = this.userApi.data;
    this.akses= this.userApi.akses;
    console.log(this.akses);
    this.tender_id = this.navParams.get('tender_id');
    
  }

  ionViewDidEnter(){
    this.getList();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  
  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    
    this.getSubscribeStatus();

    let params: any = {
      notification_code:'new_tender_note',
      reference_id     :this.tender_id
    };
    this.subsApi.getTenderSubscribers(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.list = resp.data;
        loading.dismiss();
      }else{
        this.presentToast("Tender ini belum memiliki subscribers");
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
    });
  }

  addSubscriber(){
    this.navCtrl.push(SelectPage, {
      select_mod : 1,
      tender_id : this.tender_id 
    });

  }

  deleteSubs(id, user_id){
    let params = {
      notification_code : 'new_tender_note',
      id                : id,
      user_id           : user_id,
      reference_id      : this.tender_id,
      updated_by        : this.user.user_id
    };
    
      this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
        this.getList();
      });
  }

  changeSubscribeStatus(){
    console.log("is User Susbscribe = ", this.subscribe_status);

    let params = {
      notification_code : 'new_tender_note',
      reference_id      : this.tender_id,
      user_id           : this.user.user_id,
      created_by        : this.user.user_id
    };
    if(this.subscribe_status==true){
      this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
      this.getList();
      });
    }else{
      let params = {
        id:1,
        notification_code : 'new_tender_note',
        reference_id      : this.tender_id,
        user_id           : this.user.user_id,
        updated_by        : this.user.user_id
      };
      
      this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
        this.getList();
      });
    }
  }

  getSubscribeStatus(){
    let params: any = {
      notification_code : 'new_tender_note',
      reference_id      : this.tender_id, 
      user_id           : this.user.user_id
    };
    this.subsApi.getSubscribeStatus(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.subscribe_status=true;
      }else{
        this.subscribe_status=false;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketing/list_subscribers/page.ts